import { PolfEventRankingEnum } from '@polf/shared/codegen/types'
import { useState } from 'react'

import type { LeaderboardUnionFieldsFragment } from '../../__generated__/hooks'
import Header from './Header'
import Hero from './Hero'
import type { CourseHoleSummary } from './MiniScorecard'
import TeamDetail from './TeamDetail'
import TeamRow from './TeamRow'

type ScrambleLb = Extract<
  LeaderboardUnionFieldsFragment,
  { __typename: 'ScrambleLeaderboard' }
>
type ScrambleTeam = ScrambleLb['teams'][number]

/**
 * Scramble — team-only ranking. No toggle; individual scores aren't a
 * meaningful concept in scramble (one team ball per hole). Tapping a
 * row opens the TeamDetail sheet with team-shaped stats + scorecard.
 */
const ScrambleView = ({
  lb,
  yourTeamId,
  ranking,
  courseHoles,
}: {
  lb: ScrambleLb
  yourTeamId?: string | null
  ranking?: PolfEventRankingEnum | null
  courseHoles: readonly CourseHoleSummary[]
}) => {
  const isNet = ranking === PolfEventRankingEnum.NetStrokes
  const [selected, setSelected] = useState<ScrambleTeam | null>(null)
  const teams = lb.teams ?? []
  const yourTeam = yourTeamId
    ? teams.find((t) => t.team.id === yourTeamId) ?? null
    : null
  return (
    <section className="pb-4">
      <Header />
      {yourTeam ? (
        <Hero
          yourRank={yourTeam.rank ?? null}
          yourPrimary={String(isNet ? yourTeam.score : yourTeam.points)}
          primarySuffix={isNet ? 'slag' : 'pts'}
          leaderGap={null}
          totalPlayers={teams.length}
          unit="lag"
        />
      ) : null}
      <ul className="bg-paper mx-2 rounded-lg shadow-sm overflow-hidden">
        {teams.map((entry) => (
          <TeamRow
            key={entry.team.id}
            entry={entry}
            isYou={yourTeamId != null && entry.team.id === yourTeamId}
            isNet={isNet}
            onClick={() => setSelected(entry)}
          />
        ))}
      </ul>
      <TeamDetail
        open={selected != null}
        onClose={() => setSelected(null)}
        courseHoles={courseHoles}
        data={
          selected
            ? {
                rank: selected.rank ?? null,
                teamName: selected.team.name ?? 'Uten navn',
                flightNumber: selected.team.flight?.flightNumber ?? null,
                members: selected.team.players ?? [],
                score: selected.score,
                strokes: selected.strokes,
                strokesNet: selected.strokesNet,
                points: selected.points,
                holesRegistred: selected.holesRegistred,
                scores: selected.scores,
              }
            : null
        }
      />
    </section>
  )
}

export default ScrambleView
